import 'css-chunksrc/client/pages/projectPage/budgetPage/expensesTable/expense/expenseTypeIcon/styles.scss';export default {
  "tag": "_tag_1706b_1",
  "icon": "_icon_1706b_13",
  "light": "_light_1706b_19"
};